import React from 'react';
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";


const HeaderBrand = () => {
  return (
    <div>
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/">Exactify</Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
    </div>
  )
}

export default HeaderBrand;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderBrand.js